// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Planocontas_RecalcularInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /planocontas/recalcular/{id}
 *
 * No body; the conta ID arrives in the URL segment.
 */
import { registerContract } from './validate'

export interface Planocontas_RecalcularInput {}

registerContract('Planocontas_RecalcularInput', {})
